// 需要拦截重复请求的api
// eslint-disable-next-line
export default [
  '/api/productChild/updateShelfProducts', // 子商品 上下架操作
  '/api/productChild/updateSaleProducts', // 子商品 可售不可售操作
  '/api/productParent/updateShelfProducts', // 父商品 上下架操作
  '/api/productParent/updateSaleProducts', // 父商品 可售不可售操作
  '/api/productChild/push', // 子商品推送操作
  '/api/productChild/removeStock', // 子商品去存操作
  '/api/productChild/updateProductChildAssess', // 编辑物料操作
  '/api/productChild/addProductChild', // 新增、暂存物料操作
  '/api/productParent/updateProductParent', // 编辑父商品操作
  '/api/productChild/updateProductChild', // 审核编辑提交(没有有temp)操作
  '/api/productTemp/updateProductTemp', // 审核编辑提交(有temp)
  '/api/emp/fetchPurchase', // 刷新采购人员操作
  '/api/productAssess/submitAssess', // 增量 批量提交操作
  '/api/productAssess/incrementAssociated', // 增量 图片批量关联操作
  '/api/productAssess/packProductPicAndFile', // 打包图片附件操作
  '/api/productAssess/updateApplyState', //  通过 驳回操作
  '/api/productAssess/assessManAssociated', // 待我审核 图片批量覆盖操作
  '/api/productAssess/getProductOrgInfoByAssess', // 待我审核 新增审核批量通过操作
  '/api/productAssess/batchUpdatePass', // 待我审核 修改审核批量通过操作
  '/api/productAssess/batchReject', // 待我审核 批量驳回操作
  '/api/brand/updateBrand', // 品牌编辑操作
  '/api/productAssess/reSubmitAssess', // 我发起的商品、品牌 再次提交操作
  '/api/productAssess/giveUpAssess', // 我发起的商品、品牌 放弃申请
  '/api/productAssess/stockBatchSubmit', // 发起去存 提交 批量提交 操作
  '/api/productAssess/stockAssociated', // 发起去存 关联图片 操作
  '/api/productAssess/setStockReturnUpdate', // 去存结果 返回编辑 操作
  '/api/fieldName/addFieldName', // 属性 新增、编辑操作
  '/api/fieldName/deleteField', // 属性 删除操作
  '/api/category/addCategory', // 类目 新增操作
  '/api/category/updateCategory', // 类目 编辑操作
  '/api/category/doSort', // 类目 排序操作
  '/api/category/push', // 类目 推送操作
  '/api/brand/addBrand', // 品牌 新增操作
  '/api/brand/updateBrand', // 品牌 编辑操作
  '/api/brand/push', // 品牌 推送操作
  '/api/brand/allShelf', // 品牌 全部上架操作
  '/api/brand/updateBrandsHot', // 品牌 切换热门操作
  '/api/brand/updateBrandsShelf', // 品牌 上下架操作
  '/api/brand/updateBrandsSale', // 品牌 可售不可售操作
  '/api/emptouser/doUserSetRole', // 账号授权操作
  '/api/organization/syncerporg', // 组织 更新操作
  '/api/department/update', // 部门 更新操作
  '/api/department/add', // 部门 新增操作
  '/api/department/delOrBanDepartMent', // 部门 禁用启用 操作
  '/api/department/addOrUpdateDepartMent', // 部门 推送操作
  '/api/job/update', // 岗位 编辑操作
  '/api/job/add', // 岗位 新增操作
  '/api/job/addOrUpdateJob', // 岗位推送操作
  '/api/job/delOrBanJob', // 岗位 禁启用操作
  '/api/emp/updateEmp', // 员工编辑 操作
  '/api/emp/add', // 员工 新增 操作
  '/api/emp/addOrUpdateStaff', // 员工 推送 操作
  '/api/emp/delOrBanStaff', // 员工 禁启用操作
  '/api/materageunit/add', // 计量单位 新增操作
  '/api/materageunit/unitBenchmarkPush', // 计量单位 推送操作
  '/api/material/report/submitNew', // 物料提报 保存并提交（新）操作
  '/api/material/report/submit', // 物料提报 保存并提交操作
]
// 需要拦截重复请求的api
// eslint-disable-next-line
export default [
  '/api/productChild/updateShelfProducts', // 子商品 上下架操作
  '/api/productChild/updateSaleProducts', // 子商品 可售不可售操作
  '/api/productParent/updateShelfProducts', // 父商品 上下架操作
  '/api/productParent/updateSaleProducts', // 父商品 可售不可售操作
  '/api/productChild/push', // 子商品推送操作
  '/api/productChild/removeStock', // 子商品去存操作
  '/api/productChild/updateProductChildAssess', // 编辑物料操作
  '/api/productChild/addProductChild', // 新增、暂存物料操作
  '/api/productParent/updateProductParent', // 编辑父商品操作
  '/api/productChild/updateProductChild', // 审核编辑提交(没有有temp)操作
  '/api/productTemp/updateProductTemp', // 审核编辑提交(有temp)
  '/api/emp/fetchPurchase', // 刷新采购人员操作
  '/api/productAssess/submitAssess', // 增量 批量提交操作
  '/api/productAssess/incrementAssociated', // 增量 图片批量关联操作
  '/api/productAssess/packProductPicAndFile', // 打包图片附件操作
  '/api/productAssess/updateApplyState', //  通过 驳回操作
  '/api/productAssess/assessManAssociated', // 待我审核 图片批量覆盖操作
  '/api/productAssess/getProductOrgInfoByAssess', // 待我审核 新增审核批量通过操作
  '/api/productAssess/batchUpdatePass', // 待我审核 修改审核批量通过操作
  '/api/productAssess/batchReject', // 待我审核 批量驳回操作
  '/api/brand/updateBrand', // 品牌编辑操作
  '/api/productAssess/reSubmitAssess', // 我发起的商品、品牌 再次提交操作
  '/api/productAssess/giveUpAssess', // 我发起的商品、品牌 放弃申请
  '/api/productAssess/stockBatchSubmit', // 发起去存 提交 批量提交 操作
  '/api/productAssess/stockAssociated', // 发起去存 关联图片 操作
  '/api/productAssess/setStockReturnUpdate', // 去存结果 返回编辑 操作
  '/api/fieldName/addFieldName', // 属性 新增、编辑操作
  '/api/fieldName/deleteField', // 属性 删除操作
  '/api/category/addCategory', // 类目 新增操作
  '/api/category/updateCategory', // 类目 编辑操作
  '/api/category/doSort', // 类目 排序操作
  '/api/category/push', // 类目 推送操作
  '/api/brand/addBrand', // 品牌 新增操作
  '/api/brand/updateBrand', // 品牌 编辑操作
  '/api/brand/push', // 品牌 推送操作
  '/api/brand/allShelf', // 品牌 全部上架操作
  '/api/brand/updateBrandsHot', // 品牌 切换热门操作
  '/api/brand/updateBrandsShelf', // 品牌 上下架操作
  '/api/brand/updateBrandsSale', // 品牌 可售不可售操作
  '/api/emptouser/doUserSetRole', // 账号授权操作
  '/api/organization/syncerporg', // 组织 更新操作
  '/api/department/update', // 部门 更新操作
  '/api/department/add', // 部门 新增操作
  '/api/department/delOrBanDepartMent', // 部门 禁用启用 操作
  '/api/department/addOrUpdateDepartMent', // 部门 推送操作
  '/api/job/update', // 岗位 编辑操作
  '/api/job/add', // 岗位 新增操作
  '/api/job/addOrUpdateJob', // 岗位推送操作
  '/api/job/delOrBanJob', // 岗位 禁启用操作
  '/api/emp/updateEmp', // 员工编辑 操作
  '/api/emp/add', // 员工 新增 操作
  '/api/emp/addOrUpdateStaff', // 员工 推送 操作
  '/api/emp/delOrBanStaff', // 员工 禁启用操作
  '/api/materageunit/add', // 计量单位 新增操作
  '/api/materageunit/unitBenchmarkPush', // 计量单位 推送操作
  '/api/material/report/submitNew', // 物料提报 保存并提交（新）操作
  '/api/material/report/submit', // 物料提报 保存并提交操作
]
